module.exports = __webpack_public_path__ + "static/media/igo.179bd05d.svg";